import React, { memo, useEffect, useState, useMemo, useRef } from 'react';
import TreeMultiSelectDropdown from '../../sharedcomponents/tree-multi-select-dropdown/tree-multi-select-dropdown';
import {
  Endpoints,
  ProductDeliveryPlatforms,
  ProductTypes,
} from './../../constants';
import smartHttp from '../../helpers/smartHttp';
import { getSelectedContractNumbers } from '../../helpers/component-helper-methods';

const ProductsDropdown = memo(
  ({
    DataSet,
    contracts,
    callBackProducts,
    disabled = false,
    enableSelectAll = true,
  }) => {
    const [productsResult, setProductsResult] = useState();
    const [prdCount, setPrdCount] = useState([]);
    const treeDataRef = useRef();

    useEffect(() => {
      const reduceCallback = setTimeout(async () => {
        if (contracts || DataSet) getProductsDataSet();
      }, 300);
      return () => clearTimeout(reduceCallback);
    }, [contracts, DataSet]);

    const getProductsDataSet = async () => {
      try {
        if (!DataSet) {
          if (contracts?.length > 0 && contracts?.some((el) => el.checked)) {
            let productDistributors = ProductDeliveryPlatforms?.map(
              (t) => '"' + t + '"',
            ).join(',');
            let productTypes = ProductTypes?.map((t) => '"' + t + '"').join(',');
            const { contractNumbers, contractNumberFilter } =
              getSelectedContractNumbers(contracts);
            let queryParamsProduct = {
              PageSize: 5000,
              Field: 'productName,productId,productType',
              Filter: `contractNumber in(${contractNumberFilter})
              ${
                productDistributors
                  ? 'AND (distributor in (' +
                    productDistributors +
                    ') OR producttype in (' +
                    productTypes +
                    '))'
                  : ''
              }`,
            };

            const productResponse = await smartHttp.get(
              Endpoints.contractProductsApi,
              queryParamsProduct,
            );
            let tempState = productResponse?.data?.results?.map((el, i) => {
              return { id: String(el.productId ?? i), checked: false, ...el };
            });
            setProductsResult(tempState);
          } else {
            setProductsResult([]);
          }
        } else {
          if (DataSet) {
            let tempState = DataSet?.results?.map((el, i) => {
              return { id: String(el.productId ?? i), checked: false, ...el };
            });
            setProductsResult(tempState ?? []);
          }
        }
      } catch (err) {
        setProductsResult([]);
      }
    };

    const treeData = useMemo(() => {
      if (!productsResult) return [];

      // FEATURE DISABLED (Release july-2026) - Ancillary/Legacy product grouping (flat list restored)
      // const productGroups = [
      //   { id: 'reports-group', label: 'Reports', filterFn: (product) => true },
      //   { id: 'ancillary-group', label: 'Ancillary', filterFn: (product) => product.productType === 'Ancillary' },
      //   { id: 'legacy-group', label: 'Legacy', filterFn: (product) => product.productType === 'Legacy Product' },
      // ];
      // const result = productGroups.map((group) => {
      //   const filteredProducts = productsResult.filter(group.filterFn).sort((a, b) => a.productName.localeCompare(b.productName));
      //   if (filteredProducts.length === 0) return null;
      //   return {
      //     id: group.id, label: group.label, value: group.id,
      //     children: filteredProducts.map((product) => ({
      //       id: product.id, label: product.productName, value: product.id,
      //       actualLabel: product.productName, productId: product.productId, productName: product.productName,
      //     })),
      //   };
      // }).filter(Boolean);

      const result = productsResult
        .sort((a, b) => a.productName.localeCompare(b.productName))
        .map((product) => ({
          id: product.id,
          label: product.productName,
          value: product.id,
          actualLabel: product.productName,
          productId: product.productId,
          productName: product.productName,
        }));

      treeDataRef.current = result;
      return result;
    }, [productsResult]);

    const handleSelectedProducts = (selectedIds) => {
      setPrdCount(selectedIds);

      const updatedState = selectedIds
        .map((id) => {
          const product = productsResult.find((p) => p.id === id);

          if (product) {
            return {
              productName: product.productName,
              productId: product.productId,
            };
          }
          return null;
        })
        .filter(Boolean);

      callBackProducts(updatedState);
    };

    const placeholderText =
      prdCount && prdCount.length > 0
        ? `Products (${prdCount.length})`
        : 'Products';

    return (
      <TreeMultiSelectDropdown
        ddOptions={treeDataRef.current}
        getSelectedTreeData={handleSelectedProducts}
        ddPlaceHolder={placeholderText}
        defaultChecked={prdCount}
        enableSearch={true}
        enableSelectAll={enableSelectAll}
        disabled={disabled}
      />
    );
  },
  (op, np) => op.DataSet === np.DataSet && op.contracts === np.contracts,
);

export default ProductsDropdown;
